/**
 * Checkbox Table
 *
 * Auto-initializes "select all" / row checkbox sync for any <table>
 * with a data-checkbox-table attribute.
 */

function initCheckboxTable(table: HTMLTableElement): void {
	const toggleAll = table.querySelector<HTMLInputElement>("thead input[type='checkbox']");
	const checkboxes = [...table.querySelectorAll<HTMLInputElement>("tbody input[type='checkbox']")];

	if (!toggleAll || checkboxes.length === 0) return;

	toggleAll.addEventListener('change', (event) => {
		const checked = (event.target as HTMLInputElement).checked;
		checkboxes.forEach((checkbox) => {
			checkbox.checked = checked;
		});
	});

	checkboxes.forEach((checkbox) => {
		checkbox.addEventListener('change', () => {
			const allChecked = checkboxes.every((cb) => cb.checked);
			const someChecked = checkboxes.some((cb) => cb.checked);
			toggleAll.checked = someChecked;
			toggleAll.indeterminate = someChecked && !allChecked;
		});
	});
}

export function initCheckboxTables(): void {
	document.querySelectorAll<HTMLTableElement>('[data-checkbox-table]').forEach(initCheckboxTable);
}
